v-container
  v-row
    v-col(cols="12")
      v-form(ref="formRef" v-model="valid" @submit.prevent="onSubmit")
        v-card
          v-card-text
            //- Title
            v-row
              v-col(cols="12")
                h2.text-h4.mb-4(v-html="$t('title')")
                h3.text-h6.mb-4.text-grey(v-html="$t('subtitle')")

            //- What is Ptosis
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('whatIsPtosis.heading')")
                p.text-body-1.mb-3(v-html="$t('whatIsPtosis.text1')")
                p.text-body-1.mb-3(v-html="$t('whatIsPtosis.text2')")

            v-divider.my-4

            //- How Will Surgery Affect
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('visionAppearance.heading')")
                p.text-body-1.mb-3(v-html="$t('visionAppearance.text1')")
                p.text-body-1.mb-3(v-html="$t('visionAppearance.text2')")

            v-divider.my-4

            //- Major Risks
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('risks.heading')")
                p.text-body-1.mb-3(v-html="$t('risks.text1')")
                p.text-body-1.mb-3(v-html="$t('risks.text2')")

            v-divider.my-4

            //- Alternatives
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('alternatives.heading')")
                p.text-body-1.mb-3(v-html="$t('alternatives.text')")

            v-divider.my-4

            //- Anesthesia
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('anesthesia.heading')")
                p.text-body-1.mb-3(v-html="$t('anesthesia.text')")

            v-divider.my-4

            //- Patient's Acceptance of Risks
            v-row
              v-col(cols="12")
                h3.text-h6.mb-2(v-html="$t('acceptance.heading')")
                p.text-body-1.mb-3(v-html="$t('acceptance.text')")

            v-divider.my-4

            //- Surgery Selection
            v-row
              v-col(cols="12")
                p.text-body-1.mb-3(v-html="$t('surgery.text')")
            v-row
              v-col(cols="12" md="6")
                v-radio-group(v-model="form.side" :rules="[form.validCheck('side')]")
                  v-radio(:label="$t('surgery.rightEye')" :value="$t('surgery.rightEye')")
                  v-radio(:label="$t('surgery.leftEye')" :value="$t('surgery.leftEye')")
                  v-radio(:label="$t('surgery.bothEyes')" :value="$t('surgery.bothEyes')")

            v-divider.my-6

            //- Signature Section
            v-row
              v-col(cols="12")
                NameDateSignature(
                  v-model:name="form.name"
                  v-model:date="form.date"
                  v-model:signature="form.signature"
                  :name_rules="[form.validCheck('name')]"
                  :date_rules="[form.validCheck('date')]"
                    :signature_rules="[form.validCheck('signature')]"
                )

          v-card-actions.d-flex.justify-end
            if error
              .error.text-red-lighten-1 {{ error }}
            v-btn(color="primary" type="submit" :loading="loading") {{ $t('common.submit') }}
